import { useEffect, useState } from 'react';
import { Button, Input, Textarea } from '../../components/ui';
import Modal from '../../components/ui/Modal';

interface CreateTicketModalProps {
    isOpen: boolean;
    isSaving: boolean;
    onClose: () => void;
    onCreate: (subject: string, body: string) => Promise<boolean | null>;
}

export function CreateTicketModal({ isOpen, isSaving, onClose, onCreate }: CreateTicketModalProps) {
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setSubject('');
            setBody('');
        }
    }, [isOpen]);

    const canSubmit = subject.trim().length > 0 && body.trim().length > 0;

    const handleSubmit = async () => {
        if (!canSubmit) return;
        const created = await onCreate(subject.trim(), body.trim());
        if (created) onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <Modal.Header onClose={onClose}>Novo ticket</Modal.Header>
            <Modal.Body className="space-y-4">
                <Input
                    label="Assunto"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Descreva brevemente o problema"
                    disabled={isSaving}
                />
                <Textarea
                    label="Mensagem"
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    placeholder="Conte os detalhes para nossa equipe..."
                    minRows={5}
                    disabled={isSaving}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                    Cancelar
                </Button>
                <Button onClick={() => void handleSubmit()} disabled={!canSubmit || isSaving}>
                    {isSaving ? 'Enviando...' : 'Criar ticket'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
